import { useState } from "react";

const tabs = ["Today", "Week", "Month", "12 Weeks"];

export function TimeTabs() {
  const [activeTab, setActiveTab] = useState("Today");

  return (
    <div className="w-full">
      <div className="flex space-x-4 border-b border-base-200">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`py-2 px-4 font-medium transition duration-150 ${
              activeTab === tab
                ? "border-b-2 border-primary text-primary"
                : "text-base-content/80 hover:text-primary"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="p-4">
        {/* Replace this with your tab content */}
        <p className="text-base-content/80">
          Showing data for: <strong>{activeTab}</strong>
        </p>
      </div>
    </div>
  );
}
